import React, { useState, useEffect } from 'react';
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
import { Redirect, Link } from 'react-router-dom';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import { setAuthData } from '../../actions/index';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const Login = ({ history, setAuthData, authData }) => {
	const [formData, setFormData] = useState({
		workspace: {
			name: 'workspace',
			label: 'Workspace',
			type: 'text',
			requiredFlag: true,
			forgotFlag: true,
			forgotURL: '/login/forgotworkspace',
			loadingFlag: false,
		},
		email: { name: 'email', label: 'Email', type: 'email', requiredFlag: true },
		password: {
			name: 'password',
			label: 'Password',
			type: 'password',
			requiredFlag: true,
			forgotFlag: true,
			forgotURL: '/login/forgotpassword',
		},
	});
	//true if workspace already exists
	const [isValidWorkspace, setIsValidWorkspace] = useState(false);
	// response from companyName API
	const [workspaceApiResponse, setWorkspaceApiResponse] = useState({});
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		// load icon for error
		feather.replace();
	}, [error]);

	const getRedirectUri = () => {
		//TODO: have to configure redirect URI for production
		const redirectUri = `${location.origin}/login/`;
		return redirectUri;
	};

	const handleForm = (event) => {
		const target = event.target;

		// run only for workspace input
		if (target.name === 'workspace') {
			const companyName = target.value;
			const redirectUri = getRedirectUri();
			const url = `/app/oidc/auth?companyName=${encodeURIComponent(
				companyName.toLowerCase()
			)}&redirectUri=${encodeURIComponent(redirectUri)}`;

			const params = {
				auth: 'system',
			};

			// set loading flag, before calling API
			setFormData((prevState) => ({
				...prevState,
				workspace: { ...prevState.workspace, loadingFlag: true },
			}));

			CallAPI('get', url, null, params, 0, function (response) {
				setWorkspaceApiResponse(response);

				// reset loading flag, after getting response from API
				setFormData((prevState) => ({
					...prevState,
					workspace: { ...prevState.workspace, loadingFlag: false },
				}));

				var validParams = {
					companyName: companyName,
					grant_type: null,
				};

				// workspace has other ways to login
				if (response.grant_type == 'authorization_code') {
					setIsValidWorkspace(true);

					// disable email and password inputs
					setFormData((prevState) => ({
						...prevState,
						email: { ...prevState.email, disabled: true },
						password: { ...prevState.password, disabled: true },
						workspace: { ...prevState.workspace, errorFlag: false },
					}));

					validParams.grant_type = response.grant_type;
					validParams.iss = response.iss;
					validParams.redirectUri = redirectUri;
					window.localStorage.setItem('validParams', JSON.stringify(validParams));
				}
				// workspace can be logged in through username and password
				else if (response.grant_type == 'password') {
					setIsValidWorkspace(true);

					setFormData((prevState) => ({
						...prevState,
						workspace: { ...prevState.workspace, errorFlag: false },
					}));

					validParams.grant_type = response.grant_type;
					window.localStorage.setItem('validParams', JSON.stringify(validParams));
				}
				// handle error
				else if (response.Code == '400') {
					setIsValidWorkspace(false);

					setFormData((prevState) => ({
						...prevState,
						workspace: { ...prevState.workspace, errorFlag: true },
					}));
				}
			});
		}
	};

	const handleAuthResponse = (user_info) => {
		let cookies = {};
		cookies.username = user_info.username ? user_info.username : user_info['user-info'].preferred_username;
		cookies.expiry = user_info.expr;
		cookies.userStatus = user_info.active;
		cookies.access_token = user_info.access_token;
		cookies.refresh_token = user_info.refresh_token;
		cookies.identity = user_info.identity;
		cookies.siteId = user_info.siteId;
		cookies.userId = user_info.userId ? user_info.userId : user_info['user-info'].sub;
		cookies.firstName = user_info.firstName;
		cookies.lastName = user_info.lastName;
		cookies.companyName = user_info.companyName;
		cookies.extraInfo = user_info['user-info'].extraInfo;
		return cookies;
	};

	const handleSubmit = (event) => {
		const target = event.target;

		// only submit if workspace is valid and is of password type
		if (isValidWorkspace && workspaceApiResponse.grant_type == 'password') {
			//reset error
			setError('');

			const companyName = target[0].value;
			let fd = new FormData();
			fd.append('companyName', companyName);
			fd.append('username', target[1].value);
			fd.append('password', target[2].value);
			const url = `/app/oidc/token`;

			const params = {
				auth: 'system',
			};

			// set loading flag, before calling API
			setIsLoading(true);

			CallAPI('POST', url, fd, params, 0, function (response) {
				// reset loading flag, after getting response from API
				setIsLoading(false);

				// successfull login, redirect
				if (response.Code == '204') {
					localStorage.clear();
					response.companyName = companyName;
					const cookies = handleAuthResponse(response);
					setAuthData(cookies);
					// window.localStorage.setItem('Cookies', JSON.stringify(cookies));

					appType = appType ? appType : process.env.appType;
					if (appType && appType.toLowerCase() == 'admin') history.push('/admin');
					else history.push('/');
				}
				// handle error
				else if (response.Code == '400') {
					setError('Invalid Details Provided');
				}
			});
		}

		typeof event !== 'string' ? event.preventDefault() : null;
	};

	const form = <Form label_array={formData} handleForm={handleForm} />;

	// error box
	const error_alert = (
		<div className="alert alert-outline alert-danger d-flex justify-content-center align-items-center" role="alert">
			<i data-feather="alert-circle" className="mg-r-10"></i> {error}
		</div>
	);

	// other ways to login
	const otherLoginBtn =
		workspaceApiResponse.grant_type === 'authorization_code' ? (
			<>
				<div className="divider-text">OR</div>
				<a href={workspaceApiResponse.authorizeURL}>
					<button type="button" className="btn btn-outline-primary btn-block">
						Continue with {workspaceApiResponse.buttonName}
					</button>
				</a>
			</>
		) : null;

	
	let currentPageName = location.pathname.split("/")[location.pathname.split("/").length - 1]
	// redirect if authData exists
	if (authData && typeof authData == 'object' && authData.access_token && type === 'login') { // && currentPageName !== 'workspace'
		return <Redirect to="/dataset" />;
	}
	return (
		<div
			className="mg-b-20 pd-xs-x-40 pd-x-20 pd-y-30 rounded-10"
			style={{
				boxShadow: '0 0 10px rgba(0,0,0,0.1)',
			}}
		>
			<h3 className="tx-center mg-b-20">Log in</h3>
			{error ? error_alert : null}
			<form
				autoComplete="off"
				onSubmit={handleSubmit}
				data-parsley-validate=""
				data-parsley-trigger="change"
				noValidate=""
			>
				{form}
				<input type="hidden" name="csrf" value="9002d9cd604829e57ca059215066cf46" id="csrf" />
				<button
					type="submit"
					id="submit"
					className="btn btn-primary btn-block"
					disabled={workspaceApiResponse.grant_type === 'authorization_code' || isLoading}
				>
					Log in
					{isLoading ? (
						<span className="spinner-border spinner-border-sm mg-l-10" role="status" aria-hidden="true" />
					) : null}
				</button>
			</form>
			{otherLoginBtn}
			<div className="mg-t-20 tx-center">
				Don't have an account? <Link to="/login/register">Create an Account</Link>
			</div>
		</div>
	);
};

function mapStateToProps(state) {
	return { authData: state.dataSet.authData };
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ setAuthData }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
